import { Pipe, PipeTransform } from '@angular/core';
import { DataGridColumnDefinition } from '../interfaces/data-grid.interface';
import { environment } from '@env/environment';
import isFunction from 'lodash-es/isFunction';

@Pipe({
    name: 'dataGridSorter',
    standalone: true,
})
export class DataGridSorterPipe implements PipeTransform {
    transform(value: unknown[], ...args: any[]): unknown[] {
        const column: DataGridColumnDefinition = args[0];
        const direction: number = args[1];
        let dataPreprocessingFunction: Function = args[2];

        if (column === undefined || !direction || !Array.isArray(value)) {
            return value;
        }

        if (column.dataKey === undefined) {
            if (!environment.production) {
                console.warn('A sort was attempted on a column that has no data key.');
            }
            return value;
        }

        if (!isFunction(dataPreprocessingFunction)) {
            dataPreprocessingFunction = (value: any) => value;
        }

        return value.sort((a: any, b: any) => {
            return (
                (dataPreprocessingFunction(a[column.dataKey as string]) > dataPreprocessingFunction(b[column.dataKey as string]) ? 1 : -1) *
                direction
            );
        });
    }
}
